package com.partejar.app.core.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.size
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.partejar.app.core.ui.theme.PartejarIcons
import com.partejar.app.core.ui.theme.PartejarTheme

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PartejarTopBar(
    title: String,
    modifier: Modifier = Modifier,
    subtitle: String? = null,
    leadingContent: @Composable () -> Unit = {},
    actions: @Composable RowScope.() -> Unit = {}
) {
    val dimensions = PartejarTheme.dimensions

    TopAppBar(
        title = {
            Column {
                Text(
                    text = title,
                    style = MaterialTheme.typography.titleLarge
                )

                subtitle?.let {
                    Text(
                        text = it,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
            }
        },
        modifier = modifier.heightIn(min = dimensions.topBarHeight),
        navigationIcon = leadingContent,
        actions = actions,
        windowInsets = WindowInsets.safeDrawing.only(
            WindowInsetsSides.Top + WindowInsetsSides.Horizontal
        ),
        colors = TopAppBarDefaults.topAppBarColors(
            containerColor = MaterialTheme.colorScheme.background,
            navigationIconContentColor = MaterialTheme.colorScheme.primary,
            titleContentColor = MaterialTheme.colorScheme.onBackground,
            actionIconContentColor = MaterialTheme.colorScheme.primary
        )
    )
}

@Composable
fun PartejarThemeToggleAction(
    isDarkTheme: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    contentDescription: String =
        if (isDarkTheme) "Ativar tema claro" else "Ativar tema escuro"
) {
    val dimensions = PartejarTheme.dimensions

    IconButton(
        onClick = onClick,
        modifier = modifier.size(dimensions.minimumTouchTarget)
    ) {
        Icon(
            imageVector = if (isDarkTheme) {
                PartejarIcons.Actions.lightMode
            } else {
                PartejarIcons.Actions.darkMode
            },
            contentDescription = contentDescription,
            modifier = Modifier.size(dimensions.iconDefault)
        )
    }
}